/** 図鑑用のゲームデータキー（GMO game_save/get_data 用） */
export const ENCYCLOPEDIA_DATA_KEY = 'discoveredItemIds';

/** 発見済みアイテムIDの配列をJSON文字列に変換（1024文字制限対応） */
export function serializeDiscoveredIds(ids: number[]): string {
  const unique = [...new Set(ids)].sort((a, b) => a - b);
  return JSON.stringify(unique);
}

/** JSON文字列から発見済みアイテムIDの配列を復元 */
export function parseDiscoveredIds(json: string): number[] {
  try {
    const parsed = JSON.parse(json || '[]');
    return Array.isArray(parsed)
      ? parsed.filter((v: unknown) => typeof v === 'number' && v >= 1 && v <= 137)
      : [];
  } catch {
    return [];
  }
}
